import * as VisitorTracking from '../visitorTracking';

export function initializeSchedule() {

        function safeInitModal(elementId) {
            const element = document.getElementById(elementId);
            if (element) {
                return new Modal(element);
            }
            return null;  // Return null if element is not found
        }

        const enrollmentModal = safeInitModal('zoniModal');

    document.querySelectorAll('button.zahs-admission-schedule').forEach(button => {
        button.addEventListener('click', () => {
        // 1) hide any other open modals
        document.querySelectorAll('.modal.show').forEach(modal => {
            Modal.getInstance(modal).hide();
        });

        // 2) adjust modal for the admission meeting context
        VisitorTracking.customizeForSchoolAdmissionMeeting();

        // 3) finally pop it up
        enrollmentModal.show();
        });
    });
}